/**
 * @generated SignedSource<<ccb43ab49db0f9a56f3fa3ec95a11f3f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type EventPrimaryChargeType = "PER_PERSON" | "PER_SIGN_UP";
import { FragmentRefs } from "relay-runtime";
export type EventSignupSummaryPlayerList_event$data = {
  readonly eventSeries: {
    readonly name: string;
  };
  readonly primaryChargeType: EventPrimaryChargeType | null | undefined;
  readonly " $fragmentType": "EventSignupSummaryPlayerList_event";
};
export type EventSignupSummaryPlayerList_event$key = {
  readonly " $data"?: EventSignupSummaryPlayerList_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventSignupSummaryPlayerList_event">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventSignupSummaryPlayerList_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "primaryChargeType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EventSeries",
      "kind": "LinkedField",
      "name": "eventSeries",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};

(node as any).hash = "12fb1811d9c480f20cfd42ce45180778";

export default node;
